<template>
  <div id="wrap">   
    <router-view/>      
  </div>
  
 
  <Toast />
  <ToastFcm />

 <!-- <teleport to="#modal"> -->
    <BasicModal1b
      v-if="showModal"
      @close="closeModal" 
      @ok="okModal" 
      :titleTxt="txtTitle_alert"
      :bodyTxt="txtBody_alert"
    />
  <!-- </teleport > -->

  
</template>

<script>

import { useRouter }from 'vue-router'
import {useApicall, useCheckLogin} from '@/composables/commonFn';
import Toast from '@/components/Toast.vue';
import ToastFcm from '@/components/ToastFcm.vue';
import BasicModal1b from '@/components/popups/BasicModal1b.vue';
import { useStore } from 'vuex';
import {onMounted, getCurrentInstance, ref, computed} from 'vue';
import {useGetItemList} from '@/composables/vtradeFn';
import VueCookies from "vue-cookies";
import { initializeApp } from "firebase/app";
import { getMessaging, getToken, onMessage } from "firebase/messaging";
import { useToast } from '@/composables/toast';

export default {
  name: 'App',
  components: {   
   Toast,
   BasicModal1b,
   ToastFcm
  },
  setup(){
        console.log('upgrade')
        const router = useRouter();
        const {apiCall_p, apiCall_pt, apiCall_g } = useApicall()
        //const router = useRouter();
        const store = useStore();
        var isLocal =  store.state.common.isLocal;
       // const  trace = getCurrentInstance().appContext.config.globalProperties.$log;
        const showModal = ref(false);        
        const txtTitle_alert = ref('')
        const txtBody_alert = ref('')
        const emitter = getCurrentInstance().appContext.config.globalProperties.emitter;
        const testTxt = computed(()=>store.state.common.testText)
        const { checkLogin, getMember  } = useCheckLogin();

        const  {getItemListBySessionStorage} = useGetItemList()
        // VueCookies.set('test', "testValue", "1d");
        // setTimeout(()=>{
        //   console.log("wwwwwwwwwww",  VueCookies.get('test'))
        // },3000)
       
           
  //      setTimeout(()=>{
    
  //   emitter.emit('EVENT_ALERT',{title:"알림", body:"로그인후 사용가능합니다."});
  //  }, 2000)

       var fcmToken = null
       const { triggerToastFcm } = useToast();
     

     
      var modalOKCallbackFn = null;


       emitter.on('EVENT_CHECK_LOGIN', () => {
         // console.log("EVENT_CHECK_LOGIN:")
          checkLogin();
       })



       emitter.on('EVENT_ALERT', (data) => {
      
          txtTitle_alert.value = data.title;
          txtBody_alert.value = data.body;
          showModal.value = true;
         // console.log("~~~~~~~~~~~data.fn ", data)
          if(data.fn)
          {

            modalOKCallbackFn =  data.fn;
          }
            
       })




        const setLogin = async (groundToken)=>{
           // console.log("setLogin~ groundToken", groundToken)
            const data = await apiCall_p('member/tokenlogin',{"ssotoken":groundToken})
            if(data && data.returnVal == -1049)
            {
              //최초로그인
             router.push({
               name: 'LoginFirst',              
             });
              return;
            }

            //console.log("setLogin2", data)
            if(!data)
            {
              sessionStorage.removeItem('token');  
              return; 
            }
            store.commit('user/CHANGE_IS_LOGIN', true);  
            store.commit('user/CHANGE_MEMBER_DATA', data.member);  
            store.commit('user/CHANGE_IS_PUSH_COMMENT', data.isPushComment);  
            sessionStorage.setItem('token', data.token); 
            store.dispatch('hts/setApplySpace'); 
            store.dispatch('hts/setApplySpaceEventLeague'); 
            getMember();
            setFmc();    
        }


        onMounted( async ()=>{

           
          let query = window.location.search;
          let param = new URLSearchParams(query);           
          let token = param.get('token') || param.get('accessToken');    
          let recommendId = param.get('recommendId');
          let recommendMid = param.get('recommendMid');  
         // if(token)sessionStorage.setItem('groundToken', token);         



         getMenuRewardOnOff()

          if(token)VueCookies.set('cootoken', token, "3d");
          if(recommendId)VueCookies.set('coorcId', recommendId, "3d");
          if(recommendMid)VueCookies.set('coorcMid', recommendMid, "3d");     

          
          var cooToken = VueCookies.get('cootoken'); 
        //  var groundToken = sessionStorage.getItem('groundToken');

          //console.log("cooToken:", cooToken)


           if(isLocal)
           {
               setTimeout(()=>{
                    store.dispatch('hts/setApplySpace'); 
                    store.dispatch('hts/setApplySpaceEventLeague'); 
               }, 2000)
              
           }



          if(cooToken && cooToken != null)
          {
              if(!isLocal)
              {
                  setLogin(cooToken)
              }
          }
          else
          {
              console.log("비로그인 data: groundToken 없음~~~~~~~~") 
          }


         if(!sessionStorage.getItem('startItem_S'))
         {           
            let items =   await getItemListBySessionStorage('S')
            sessionStorage.setItem('startItem_S', JSON.stringify(items[0])); 
                   
         }

         if(!sessionStorage.getItem('startItem_F'))
         {           
            let items =   await getItemListBySessionStorage('F')
            sessionStorage.setItem('startItem_F', JSON.stringify(items[0]));
                      
         }

         if(!sessionStorage.getItem('startItem_C'))
         {           
            let items =   await getItemListBySessionStorage('C')
            sessionStorage.setItem('startItem_C', JSON.stringify(items[0]));  
                
         }

         if(!sessionStorage.getItem('startItem_G'))
         {           
            let items =   await getItemListBySessionStorage('G')
            sessionStorage.setItem('startItem_G', JSON.stringify(items[0]));            
         }

       

          //console.log("aaaa:", JSON.parse(sessionStorage.getItem('startItem_G')), JSON.parse(sessionStorage.getItem('startItem_F')))





        })


        const getMenuRewardOnOff = async() => {
          var res = await apiCall_g(`index/getsettingdetail?key=MENU_REWARD`);
          var result = res.data;
          if(!result) result = '';
          store.commit('common/CHANGE_MENU_REWARD_STATE', result.VALUE);
        } 

        const setFmc = () =>{

          //#1. 웹 워커 등록
          navigator.serviceWorker
            .register("/sw.js")
            .then(function (registration) {
              console.log("Service worker successfully registered.");
              return registration;
            })
            .catch(function (err) {
              console.error("Unable to register service worker.", err);
            });

          const firebaseConfig = {  //파이어베이스 프로젝트에서 가져올 수 있습니다.
            apiKey: "AIzaSyC4aimH1xUds3sOa62kIOkZDlGx0v1av58",
            authDomain: "flexmoney-b733c.firebaseapp.com",
            projectId: "flexmoney-b733c",
            storageBucket: "flexmoney-b733c.appspot.com",
            messagingSenderId: "511733610121",
            appId: "1:511733610121:web:389c5fb7976e4b1ed97858",
            measurementId: "G-520JKRHBRY"
          };

          //#2. 파이어베이스 접속
          const firebase = initializeApp(firebaseConfig);
          const messaging = getMessaging(firebase);
          //messaging.subscribeToTopic('all');

          console.log("firebase:", firebase, "messaging :", messaging )
          Notification.requestPermission()
          .then((permission) => {
            console.log('permission ', permission)
            // if (permission !== 'granted') {
            //   alert('알림을 허용해주세요')
            // }
          })

          getToken(messaging, {
            vapidKey:'BNMULNiN7cmWYqHGLdsSuXLTkGXa-CqyOResXkOnUr7g2Su-ARXKAEih0MNpbJbsaWSQ3qXsBFNAqsQ2WNgkMBk',
          })
            .then(async (token) => {
            //   console.log('해당 브라우저에서의 토큰 : ', token);
              fcmToken = token;
              store.commit('user/CHANGE_FCM_TOKEN', fcmToken); 
            //   console.log("tokenregister:",  fcmToken)
              if(fcmToken)
              {
                  const res =  await apiCall_pt('fcm/tokenregister',{"fcmtoken":fcmToken, "platform" :  "web"})
                  console.log("tokenregister:",  res)
              }


            })
            .catch((err) => {
              console.log('err :', err);
            });

          //#3. 파이어베이스 메시징 기능 사용 적용
          onMessage(messaging, (payload) => {
            console.log("Message received.1111 ", payload);
            triggerToastFcm(payload);
            // if (Notification.permission === "granted") {
            //   navigator.serviceWorker.ready
            //     .then((registration) => {
            //       //console.log("registration", registration)
            //       registration
            //         .showNotification(payload.data.title, {
            //           body: payload.data.body,
            //           icon: "/favicon.ico",
            //           image: payload.data.image?payload.data.image:null,
            //           linkUrl: payload.data.linkUrl?payload.data.linkUrl:null,   
            //         //  vibrate: [200, 100, 200, 100, 200, 100, 200],
            //         //  tag: "vibration-sample",
            //         })
            //         .finally((arg) => console.log("arg:", arg));
            //     })
            //     .catch((err) => {
            //       console.log(err);
            //     });
            // }

          });

     

          //#4. 브라우저 백그라운드 진입시 사용할 파일 적용
          if ("serviceWorker" in navigator) {
            navigator.serviceWorker
              .register("/firebase-messaging-sw.js")
              .then(function (registration) {
                console.log("ServiceWorker registration successful with scope: ", registration);
              });
          }

        }




        const closeModal =()=>{
          showModal.value = false; 
        }

        const okModal = () =>{
          //console.log("modalOKCallbackFn", modalOKCallbackFn)
          showModal.value = false; 
          if(modalOKCallbackFn)
          {
            modalOKCallbackFn()
            modalOKCallbackFn = null;
            //console.log("modalOKCallbackFn:", modalOKCallbackFn)
          }
          
        }
    return{
      showModal,
      closeModal,
      txtBody_alert,
      txtTitle_alert,
      okModal,
      testTxt
    }
  }
}
</script>

<style>
   

    @import  './assets/css/ui.css';
    @import  './assets/css/trade.css';
    @import  './assets/css/micromodal.css';
</style>
